"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[5814],{

/***/ 5730:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ toggleScroll)
/* harmony export */ });
/**
 * * Applies scroll locked styles to the docuemnt body
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */

function toggleScroll({ lock } = { lock: true }) {
  if (lock) {
    lockScroll()
  } else if (document.body.style.overflow === 'hidden') {
    unlockScroll()
  }
}

function lockScroll() {
  const scrollPosition = window.scrollY

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollPosition}px`
  document.body.style.width = '100%'
}

function unlockScroll() {
  const scrollPosition = parseInt(document.body.style.top) * -1

  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('position')
  document.body.style.removeProperty('top')
  document.body.style.removeProperty('width')

  if (!scrollPosition) return
  window.scrollTo({ top: scrollPosition, behavior: 'instant' })
}


/***/ }),

/***/ 5814:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ search)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5730);



function search() {
  var $parent = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.documentElement).add('body')
  var $page = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#MainContent')
  var selectors = {
    searchBtn: '.js-search-header',
    closeSearch: '.js-search-header-close',
    searchContainer: '.site-header__search-container',
    searchInput: '.site-header__search-input',
    openAlgoliaSearchButton: '[data-algolia-search-trigger]',
    tabletAlgoliaSearchButton: '[data-tablet-algolia-search-trigger]',
    algoliaSearchContainer: '[data-algolia-search-container]',
    algoliaSearchInput: '.aa-Input',
  }

  var config = {
    namespace: '.siteNav',
  }

  ;(function init() {
    searchDrawer()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(selectors.openAlgoliaSearchButton, function ($el) {
      $el.on('click', openAlgoliaSearchDrawer)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(selectors.closeSearch, function ($el) {
      $el.on('click', function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchBtn).attr('aria-expanded', 'false')
        closeAlgoliaSearchDrawer()
      })
    })
  })()

  function openAlgoliaSearchDrawer(e) {
    e.preventDefault()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.tabletAlgoliaSearchButton).addClass('ag:hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.algoliaSearchContainer).removeClass('ag:hidden').addClass('ag:flex')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.algoliaSearchInput).trigger('focus')
    ;(0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({ lock: true })
    // Clicking out of container closes it
    $page.on('click' + config.namespace, function () {
      closeAlgoliaSearchDrawer()
      return false
    })

    $parent.on('keyup' + config.namespace, function (e) {
      if (e.key === 'Escape') {
        closeAlgoliaSearchDrawer()
      }
    })
  }

  function closeAlgoliaSearchDrawer() {
    // deselect any focused form elements
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.activeElement).trigger('blur')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.tabletAlgoliaSearchButton).removeClass('ag:hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.algoliaSearchContainer).addClass('ag:hidden').removeClass('ag:flex')

    $page.off('click' + config.namespace)
    $parent.off('keyup' + config.namespace)
    ;(0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({ lock: false })
  }

  function searchDrawer() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchBtn).on('click', function (evt) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchBtn).attr('aria-expanded', 'true')
      evt.preventDefault()
      openSearchDrawer()
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.closeSearch).on('click', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchBtn).attr('aria-expanded', 'false')
      closeSearchDrawer()
    })
  }

  function openSearchDrawer() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchContainer).addClass('is-active')
    $parent.addClass('js-drawer-open--search')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchInput).focus()
    // Clicking out of container closes it
    $page.on('click' + config.namespace, function () {
      closeSearchDrawer()
      return false
    })

    $parent.on('keyup' + config.namespace, function (evt) {
      if (evt.keyCode === 27) {
        closeSearchDrawer()
      }
    })
  }

  function closeSearchDrawer() {
    // deselect any focused form elements
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.activeElement).trigger('blur')

    $parent.removeClass('js-drawer-open--search').off(config.namespace)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.searchContainer).removeClass('is-active')

    $page.off('click' + config.namespace)
    $parent.off('keyup' + config.namespace)
  }
}


/***/ })

}]);